<template>
   <div class="state-form mb-4">
      <b-form-row class="mb-2">
         <b-col class="d-flex align-items-center">
            <label :for="'input-state-' + index" class="mb-0">State</label>
         </b-col>
         <b-col class="d-flex align-items-center justify-content-end">
            <div :id="`btn-delete-state-${index}`" class="delete-btn" @click="removeState">
               <b-icon icon="x-square" v-b-tooltip.left="'Remove this state'"></b-icon>
            </div>
         </b-col>
      </b-form-row>
      <b-form-select
         :id="`input-state-${index}`"
         class="mb-3"
         :options="stateOptions"
         @input="onInput"
         v-model="state"
      >
         <template #first>
            <b-form-select-option :value="null" disabled> Please select one </b-form-select-option>
         </template>
      </b-form-select>
   </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
   props: ['index', 'value'],
   data() {
      return {
         state: this.value,
      };
   },
   computed: {
      ...mapGetters({
         usStates: 'usStates',
      }),

      stateOptions() {
         const stateOptions = Object.entries(this.usStates).map((entry) => {
            const [key, value] = entry;
            return {text: value, value: key};
         });
         return stateOptions;
      },
   },
   methods: {
      onInput() {
         this.$emit('input', this.state);
      },
      removeState() {
         this.$emit('remove');
      },
   },
   watch: {
      value(value) {
         this.state = value;
         this.onInput();
      },
   },
};
</script>

<style lang="scss" scoped>
.state-form {
   padding: 15px;
   background-color: rgba(#000000, 0.075);
}
</style>
